import { useMemo } from "react";
import { ORDER_TYPES } from "../../../components/OrderTypeSelector/orderTypeSelectorConstants";
import { LITE_TRADE_POSITION_SIDE } from "../../../modules/LiteTrade/liteTradeConstants";

export const useMobilePositionFormErrors = (props) => {
    const {
        additionalFields,
        amount,
        assetInstance,
        isCheckFreeMargin = true,
        currentPrice,
        lots,
        metrics,
        orderType,
        side,
        stopLossActive,
        takeProfitActive,
    } = props;
    return useMemo(() => {
        const isBuy = side === LITE_TRADE_POSITION_SIDE.BUY;
        const isSell = side === LITE_TRADE_POSITION_SIDE.SELL;
        let comparePrice = currentPrice;
        if (!assetInstance || !metrics) return true;
        const errors = {};
        if (lots < assetInstance.getMinOrderSizeLots()) errors.lots = 'error.min_lots_size';
        if (lots > assetInstance.getMaxOrderSizeLots()) errors.lots = 'error.max_lots_size';
        if (isCheckFreeMargin && metrics?.['marginFree'] < amount) errors.lots = 'error.margin_free_not_enough';
        if (isBuy) {
            if (orderType === ORDER_TYPES.LIMIT) {
                if (additionalFields['limitPrice'] > comparePrice) errors.limitPrice =
                    'error.input_price_must_less_compare_price';
                comparePrice = additionalFields['limitPrice'];
            } else if (orderType === ORDER_TYPES.STOP) {
                if (additionalFields['stopPrice'] < comparePrice) errors.stopPrice =
                    'error.input_price_must_more_compare_price';
                comparePrice = additionalFields['stopPrice'];
            }
            if (stopLossActive && additionalFields['stopLoss'] >= comparePrice) errors.stopLoss =
                'error.input_price_must_less_compare_price';
            if (takeProfitActive && additionalFields['takeProfit'] <= comparePrice) errors.takeProfit =
                'error.input_price_must_more_compare_price';
        } else if (isSell) {
            if (orderType === ORDER_TYPES.LIMIT) {
                if (additionalFields['limitPrice'] < comparePrice) errors.limitPrice =
                    'error.input_price_must_more_compare_price';
                comparePrice = additionalFields['limitPrice'];
            } else if (orderType === ORDER_TYPES.STOP) {
                if (additionalFields['stopPrice'] > comparePrice) errors.stopPrice =
                    'error.input_price_must_less_compare_price';
                comparePrice = additionalFields['stopPrice'];
            }
            if (stopLossActive && additionalFields['stopLoss'] <= comparePrice) errors.stopLoss =
                'error.input_price_must_more_compare_price';
            if (takeProfitActive && additionalFields['takeProfit'] >= comparePrice) errors.takeProfit =
                'error.input_price_must_less_compare_price';
        }
        return errors;
    }, [
        additionalFields,
        amount,
        assetInstance,
        currentPrice,
        isCheckFreeMargin,
        lots,
        metrics,
        orderType,
        side,
        stopLossActive,
        takeProfitActive,
    ])
}
